import React from 'react'
import { IonCard } from '@ionic/react';

//	S T Y L E

import './com-digitalmenu-preview.scss'

//	S T A T E S   -   P R O P S

import { props___ComDigitalMenuPreviewComponent } from './com-digitalmenu-preview.state';

//	C L A S S

export default class ComDigitalMenuPreviewComponent extends React.Component<props___ComDigitalMenuPreviewComponent, {}> {

//#region 																							C O N S T R U C T O R

	constructor(
		public props: props___ComDigitalMenuPreviewComponent,
	) {
		super(props);
	}

//#endregion

//#region 																							R E N D E R

	render() : React.ReactNode {
		return <>
			<IonCard className="com-digitalmenu-preview---container">

				<div className="com-digitalmenu-preview---index">
					<div>Categoria Cibo 1</div>
					<div>Categoria Cibo 2</div>
					<div>Bevande</div>
				</div>

				<br />

				<div className="com-digitalmenu-preview---card">
				
					<div className="com-digitalmenu-preview---card---title">
						<h2>Categoria Cibo 1</h2>
					</div>
				
					<br />

					<div className="com-digitalmenu-preview---card---content">
						<div className="com-digitalmenu-preview-dish---container">
							<div>
								<div>Cibo 1</div>
								<div>
									<div>
										<b>10,00 €</b>
									</div>
								</div>
							</div>
							<span></span>
						</div>
						<div className="com-digitalmenu-preview-dish---container">
							<div>
								<div>Cibo 2</div>
								<div>
									<div>
										<b>8,50 €</b>
									</div>
								</div>
							</div>
							<span></span>
						</div>
					</div>
				</div>
				<br />

				<br />
				<br />
				<br />
				<br />

				<div className="com-digitalmenu-preview---go-up">
					<i className="fas fa-chevron-up"></i>
				</div>

			</IonCard>
		</>;
	}

//#endregion

}